import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import GroupBookingRequest from './GroupBookingRequest';
import './FlightGroupBooking.scss';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import { getUserDetails } from '../../api/profileApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
// import AccountsPageHorizontalBar from '../profile/accounts/AccountsPageHorizontalBar';

const BOOKING = 'groupBooking';

function FlightGroupBooking() {
  const [selectedTab] = useState(BOOKING);
  const [agent, setAgent] = useState(undefined);
  const [isLoading, setLoading] = useState(false);

  const getUserData = async () => {
    setLoading(true);
    const response = await getUserDetails(getUserAgentId());
    if (response?.ApiStatus?.Status === 'OK') {
      const user = response?.ApiStatus?.Result?.User;
      setAgent(user);
    }
    setLoading(false);
  };

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <section className="agent-support-page py-4">
      <AppLoading isLoading={isLoading} />
      {/* <AccountsPageHorizontalBar selectedPage="group-booking" /> */}
      {agent ? (
        <div className="agent-support-page_container">
          <div className="agent-support-page_header">Group Booking</div>
          <Row className="spacing-8 p-3">
            <Col lg={6} md={8} sm={12} xs={12}>
              <div>
                {selectedTab === BOOKING && (
                  <GroupBookingRequest agent={agent} />
                )}
              </div>
            </Col>
          </Row>
        </div>
      ) : (
        <div>Failed to fetch Agent Details</div>
      )}
    </section>
  );
}
export default FlightGroupBooking;
